export default __webpack_public_path__ + "static/media/CheckMark.662d8d35.svg";